import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';

interface IPagerProps {
  current: number,
  count: number,
  url: string
}

export default function Pager(props: IPagerProps) {
  return (
    <Container>
      <div className="maxwidth">
        {Array(props.count).fill(0).map((_item, index) => {
          return (
            <Link href={`${props.url}/${index}`}
              key={index}
              className={index === props.current ? 'current' : ''}>
              {(index + 1).toString()}
            </Link>
          );
        })}
      </div>
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 45px;
    margin-top: 50px;

    & > div {
        justify-content: center;
        display: flex;
        align-items: center;
    }

    & a {
        background-color: var(--color-bg-lightgray);
        border: 1px solid #eee;
        padding: 5px 10px;
        border-radius: 50%;
        margin: 0 5px;
    }

    .current, a:hover {
        background-color: var(--red);
        color: #fff !important;
    }
`

export const PagerBox = styled.div`
  width: 100%;
`